import { Button } from '@evaneos/b2b-ui/legacy';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { setContractEditStep } from '../../../../../resources/contract';
import { ContractEditStep } from '../../../../../resources/contract/types';
import { DossierId } from '../../../../../resources/dossier/types';
import { useAppDispatch } from '../../../../../shared/redux';

import s from './Reschedule.module.css';

type RescheduleProps = {
    dossierId: DossierId;
    onRescheduleButtonClick?: () => void;
};

export const Reschedule = ({ dossierId, onRescheduleButtonClick }: RescheduleProps) => {
    const dispatch = useAppDispatch();

    const handleClick = () => {
        dispatch(setContractEditStep(ContractEditStep.TRAVEL_INFORMATION));
        if (onRescheduleButtonClick) {
            onRescheduleButtonClick();
        }
    };

    return (
        <div className={s.rescheduleContainer}>
            <h3 className={s.title}>
                <FormattedMessage id="dossier.reschedule.title" />
            </h3>
            <p>
                <FormattedMessage id="dossier.reschedule.information" />
            </p>
            {onRescheduleButtonClick ? (
                <Button priority="primary" onClick={handleClick}>
                    <FormattedMessage id="dossier.reschedule.button" />
                </Button>
            ) : (
                <Link
                    to={{ pathname: `/dossier/${dossierId}/contract/edit` }}
                    onClick={handleClick}
                >
                    <Button priority="primary">
                        <FormattedMessage id="dossier.reschedule.button" />
                    </Button>
                </Link>
            )}
        </div>
    );
};
